var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChairStreamlineFlex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-1.43 -1.43 40 40",
    id: "Chair--Streamline-Flex",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Chair Streamline Icon: https://streamlinehq.com\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chair--chair-business-product-comfort-decoration-sit-furniture"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 319",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.515549785714286 11.200813842857144v9.421011985714287",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 320",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M30.624317571428577 11.200813842857144v9.421011985714287",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 518",
    fill: "#ffffff",
    d: "M18.571857 3.316071428571429c-6.028140342857143 0 -10.5492456 -0.88428483 -12.056307214285715 -1.3264285714285715v9.285026528571429c1.004716585714286 0.44212517142857144 4.822522885714286 1.3264285714285715 12.056307214285715 1.3264285714285715s11.051537571428572 -0.8843034000000001 12.056174571428572 -1.3264285714285715V1.9896428571428573c-1.506822857142857 0.4421437414285715 -6.0280077 1.3264285714285715 -12.056174571428572 1.3264285714285715Z",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 519",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.571857 3.316071428571429c-6.028140342857143 0 -10.5492456 -0.88428483 -12.056307214285715 -1.3264285714285715v9.285026528571429c1.004716585714286 0.44212517142857144 4.822522885714286 1.3264285714285715 12.056307214285715 1.3264285714285715s11.051537571428572 -0.8843034000000001 12.056174571428572 -1.3264285714285715V1.9896428571428573c-1.506822857142857 0.4421437414285715 -6.0280077 1.3264285714285715 -12.056174571428572 1.3264285714285715Z",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 321",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1.9896428571428573 19.155830442857145c1.3816875857142858 0.6614634 6.632142857142858 2.647657542857143 16.580357142857142 2.647657542857143s15.198749142857142 -1.986194142857143 16.580357142857142 -2.647657542857143",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 515",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m6.057003428571429 20.559642857142858 22.338118285714287 14.590714285714286",
    strokeWidth: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 517",
    stroke: "#18202f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m31.08299657142857 20.559642857142858 -22.338038700000002 14.590714285714286",
    strokeWidth: 2.86
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChairStreamlineFlex);
export default __webpack_public_path__ + "static/media/Chair--Streamline-Flex.2d4392c6b9058b4f30bdc67f1fb432d2.svg";
export { ForwardRef as ReactComponent };